import { render, staticRenderFns } from "./CategoryDialog.vue?vue&type=template&id=66afe931"
import script from "./CategoryDialog.vue?vue&type=script&lang=ts"
export * from "./CategoryDialog.vue?vue&type=script&lang=ts"
import style0 from "./CategoryDialog.vue?vue&type=style&index=0&id=66afe931&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports